import { Paths } from "configs";

import { ResetPassword } from "./ResetPassword";

export const ResetPasswordRoutes = [
  {
    path: Paths.resetPasswordPath,
    element: <ResetPassword />,
  },
];
